import { render, staticRenderFns } from "./Faturas.vue?vue&type=template&id=77b99894&scoped=true&"
import script from "./Faturas.vue?vue&type=script&lang=js&"
export * from "./Faturas.vue?vue&type=script&lang=js&"
import style0 from "./Faturas.vue?vue&type=style&index=0&id=77b99894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b99894",
  null
  
)

export default component.exports